import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RoutesWrap from "./App";
// Imported AFTER ./App on purpose: webpack emits main.css in module-import
// order, so this puts the phone/tablet media queries last among the eagerly
// loaded stylesheets. The rules are also `body`-prefixed so they still win
// against lazy page chunks, whose CSS is injected at runtime — see the header
// comment in responsive.css.
import "./styles/responsive.css";
import reportWebVitals from "./reportWebVitals";
import { StoreProvider } from "easy-peasy";
import store from "./store";
import { registerLicense } from '@syncfusion/ej2-base';
import { IConfig } from "./types/IConfig";
import { logger } from "./utility/logger";

// The Syncfusion license key is delivered via window.config, never committed to source.
// Two paths (same as stsAuthority): at runtime from config.aspx (server SYNCFUSION_KEY
// env var), or — when config.aspx is unavailable — from the index.html fallback object,
// whose __SYNCFUSION_KEY__ token the dev pipeline injects at build from the Key Vault
// secret `SyncfusionKey`. If absent (e.g. local dev without a config source) Syncfusion
// falls back to trial mode.
const syncfusionKey = (window as unknown as { config?: IConfig }).config?.syncfusionKey;
if (syncfusionKey) {
  registerLicense(syncfusionKey);
} else {
  logger.warn("Syncfusion license key not found in window.config; running in trial mode.");
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <RoutesWrap />
    </StoreProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
